import { render, staticRenderFns } from "./SidePanelAdsVast.vue?vue&type=template&id=352860e5&scoped=true"
import script from "./SidePanelAdsVast.vue?vue&type=script&lang=js"
export * from "./SidePanelAdsVast.vue?vue&type=script&lang=js"
import style0 from "./SidePanelAdsVast.vue?vue&type=style&index=0&id=352860e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352860e5",
  null
  
)

export default component.exports